import type { Process } from "@archlang/scene/arch-model";

/**
 * Stable lookup key for a process. Uses the stable ID when present;
 * otherwise the fully-qualified name (`Owner.Path.Name`) so two modules
 * carrying the same short process name don't collide.
 */
export function processKey(p: Process): string {
  if (p.id) return p.id;
  const qn =
    p.ownerPath && p.ownerPath.length > 0 ? `${p.ownerPath.join(".")}.${p.name}` : p.name;
  // v0.11 (D2): the landed space prefixes the no-id key — mirrors the
  // engine's processIdentity, so hand-built models key like wire ones
  // (which carry the engine-minted id already). Spaceless unchanged.
  return p.space ? `${p.space}::${qn}` : qn;
}

/** Fully-qualified name without falling back to the stable ID. */
export function processQualifiedName(p: Process): string {
  return p.ownerPath && p.ownerPath.length > 0
    ? `${p.ownerPath.join(".")}.${p.name}`
    : p.name;
}
